import { Box, Heading, List, Text } from '@ksyos/design-system';
import type {
    AbstractSyntaxTreeBuilderNode,
    AbstractSyntaxTreeRenderer,
} from '@common/utils/abstractSyntaxTreeBuilder';

export class AbstractSyntaxTreeReactRenderer implements AbstractSyntaxTreeRenderer<JSX.Element> {
    public render(nodes: AbstractSyntaxTreeBuilderNode[]) {
        return (
            <Box pt={[0, null, 1]}>
                {nodes.map((node) => {
                    if (node.type === 'header') {
                        return (
                            <Heading
                                key={node.key}
                                size="xsmall"
                            >
                                {node.value}
                            </Heading>
                        );
                    }

                    if (node.type === 'paragraph') {
                        return (
                            <Text
                                key={node.key}
                                mb={6}
                                size="sm"
                            >
                                {node.value}
                            </Text>
                        );
                    }

                    if (node.type === 'unordered-list') {
                        return (
                            <List
                                key={node.key}
                                size="small"
                                sx={{ mb: 6 }}
                            >
                                {node.children.map((listItem) => (
                                    <List.Item key={listItem.key}>{listItem.value}</List.Item>
                                ))}
                            </List>
                        );
                    }

                    return null;
                })}
            </Box>
        );
    }
}
